class FooterRedirect {
    constructor(element) {
        this.element = element;
        this.init();
    }
        
    init() {
        var selectedItem = this.element;
        
        document.addEventListener('input', function (event) {  
            var options = selectedItem.getElementsByTagName("OPTION");
                    
            for (var i = 0; i < options.length; i++) {
                if (options[i].selected) {
                    console.log(options[i]);
                    console.log(options[i].selected);
                    window.location.href=options[i].value;
                }
            }
        });
    };
}

export default FooterRedirect;


